import React, { useEffect } from "react";

import { StoreState, Mill } from "models";
import { fetchMills, selectMill, selectLine } from "redux/MillSelector/MillSelector.actions";
import { SetMillLocalTime } from "redux/TimeSelector/TimeSelector.actions";
import { setDamperConfigs } from "redux/Dampers/Dampers.actions";
import { useDispatch, useSelector } from "react-redux";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import { ValmetGrey10, ValmetGrey4 } from "../../theme";

const localStyles = makeStyles((theme: Theme) =>
  createStyles({
    mainContainer: {
      display: "flex",
      flexDirection: "column",
    },
    selectorContainer: {
      display: "flex",
      flexDirection: "column",
      marginBottom: theme.spacing(2),
      color: ValmetGrey4,
      fontSize: "1rem",
      fontFamily: "Roboto, Helvetica, Arial, sans-serif",
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: "120px",
    },
    selector: {
      width: "100%",
      padding: theme.spacing(1),
      background: "white",
      border: `1px solid ${ValmetGrey10}`,
      borderRadius: "3px",
      boxSizing: "border-box",
      outline: "none",
      cursor: "pointer",
    },
  }),
);

const MillSelector = () => {
  const localClasses = localStyles();
  const dispatch = useDispatch();

  const fetching = useSelector((state: StoreState) => state.millSelector.fetching);
  const didInvalidate = useSelector((state: StoreState) => state.millSelector.didInvalidate);
  const mills: Mill[] = useSelector((state: StoreState) => state.millSelector.mills);
  const selectedMill: Mill | null = useSelector((state: StoreState) => state.millSelector.selectedMill);
  const selectedLineId: string | null = useSelector((state: StoreState) => state.millSelector.selectedLineId);
  const clientId: string | null = useSelector((state: StoreState) => state.login.user?.clientId ?? null);

  useEffect(() => {
    if (clientId) {
      dispatch(fetchMills(clientId));
    }
  }, [dispatch, clientId]);

  const handleChangeMill = (event: React.ChangeEvent<{ value: unknown }>) => {
    const selectedMillId = event.target.value as string;
    const selectedMill = mills.find((mill) => mill.millId === selectedMillId);

    if (selectedMill) {
      dispatch(selectMill(selectedMill));
      dispatch(SetMillLocalTime(parseInt(selectedMill.offset)));
    }
  };

  const handleChangeLine = (event: React.ChangeEvent<{ value: unknown }>) => {
    const lineId = event.target.value as string;
    dispatch(setDamperConfigs([], true));
    dispatch(selectLine(lineId));
  };

  return (
    <div className={localClasses.mainContainer}>
      <div className={localClasses.selectorContainer}>
        <label htmlFor="millselection">Mill</label>
        <select
          className={localClasses.selector}
          value={selectedMill?.millId}
          id="millselection"
          onChange={(event) => handleChangeMill(event)}
          disabled={fetching || didInvalidate}
        >
          {mills.length ? (
            mills.map((option: Mill) => (
              <option key={option.millId} value={option.millId}>
                {option.millId}
              </option>
            ))
          ) : (
            <option>{fetching ? "Loading mills" : "No mills"}</option>
          )}
        </select>
      </div>

      <div className={localClasses.selectorContainer}>
        <label htmlFor="lineselection">Line</label>
        <select className={localClasses.selector} id="lineselection" value={selectedLineId ?? ""} onChange={(event) => handleChangeLine(event)}>
          {selectedMill && selectedMill.lineIds ? (
            selectedMill.lineIds.map((lineId: string) => (
              <option key={lineId} value={lineId}>
                {lineId}
              </option>
            ))
          ) : (
            <option value="No lines">No lines</option>
          )}
        </select>
      </div>
    </div>
  );
};

export default MillSelector;
